/**
 * Opens the "Ask Mimic" chat drawer from anywhere (widget ⋯ → "Ask about this insight", recommendation
 * cards, report sections). `context` is sent with the first message so the agent knows what the user sees.
 */
export interface AskRequest {
  prompt?: string;
  /** Auto-send `prompt` instead of just prefilling the composer. */
  send?: boolean;
  context?: Record<string, unknown>;
  title?: string;
}

type Listener = (req: AskRequest) => void;
const listeners = new Set<Listener>();

export function openAsk(req: AskRequest = {}): void {
  for (const l of listeners) l(req);
}

export function subscribeAsk(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
